import { PropsWithChildren, ReactNode } from "react";
import { Dialog } from "@ark-ui/react";

import Button from "@/components/button/button";
import { Icon } from "@/components/icon/icon";

interface DialogHeaderProps {
  title?: ReactNode;
  description?: ReactNode;
}

const DialogHeader = ({ title, description }: DialogHeaderProps) => {
  return (
    <DialogHeader.Root>
      <Dialog.Title>{title}</Dialog.Title>
      {description && <Dialog.Description>{description}</Dialog.Description>}

      <Dialog.CloseTrigger asChild>
        <Button variant="ghost">
          <Icon name="x" />
        </Button>
      </Dialog.CloseTrigger>
    </DialogHeader.Root>
  );
};

export default DialogHeader;

DialogHeader.Root = function DialogHeader_Root({ children }: PropsWithChildren) {
  return (
    <div data-scope="dialog" data-part="header">
      {children}
    </div>
  );
};

DialogHeader.Title = Dialog.Title;
